/**
* @Author: Matthias Gohla <Matze>
* @Date:   2016-08-01T10:36:38+02:00
* @Email:  matze_lebt@gmx.de
* @Last modified by:   mBook
* @Last modified time: 2016-10-11T11:00:22+02:00
*/
import React from 'react';
import PropTypes from 'prop-types';
import getDisplayName from './getDisplayName';

/**
 * Compose inputs with standard props
 * @param  {Class} WrappedComponent    Child Component
 * @return {Class} InputProps  Parent component
 */
export default function inputProps(WrappedComponent) {
  /**
     * InputProps - handles disabled props for inputs
     * so the proper visual-state is passed as class name to the input.
     * It also prevents onPress functions to be triggered when disabled
     * is true.
     * @param {Class} props
     */
  function InputProps({
    disabled,
    error,
    onPress,
    ...other
  }) {
    let visualState = '';

    if (disabled) {
      visualState += 'disabled';
    }

    if (error) {
      if (visualState.length > 0) visualState += ' ';
      visualState += 'error';
    }

    return (
      <WrappedComponent
        {...other}
        disabled={disabled}
        visualState={visualState}
        onPress={(disabled) ? null : onPress}
      />
    );
  }
  InputProps.propTypes = {
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    onPress: PropTypes.func,
  };
  InputProps.defaultProps = {};

  InputProps.displayName = `InputProps(${getDisplayName(WrappedComponent)})`;

  return InputProps;
}

